import { isLocale, type Locale } from '@wikigold/i18n';
import { localePath } from './locale-routing';

export function isIntroductionPath(pathname: string): boolean {
  return pathname === '/';
}

export function introLocaleFromSearch(search: string): Locale | null {
  const language = new URLSearchParams(search).get('lang');
  return language && isLocale(language) ? language : null;
}

export function gameEntryHref(locale: Locale, search: string, hash: string): string {
  return `/${locale}/${search}${hash}`;
}

export function localeSelectionHref(locale: Locale, pathname: string, search: string, hash: string): string {
  if (!isIntroductionPath(pathname)) return `${localePath(locale, pathname)}${search}${hash}`;
  const query = new URLSearchParams(search);
  query.set('lang', locale);
  return `/?${query.toString()}${hash}`;
}
